import { ThemeEvents } from "@theme/events";

// console.log('✅ Variant → Media sync loaded (Desktop + Mobile)');

document.addEventListener("DOMContentLoaded", () => {
  /* ------------------ DESKTOP ------------------ */
  const scrollToVariantMediaDesktop = (variant) => {
    if (!variant?.featured_media?.id) return;
    const mediaId = variant.featured_media.id;

    const attempt = () => {
      const targetLi = document.querySelector(
        `media-gallery li[data-media-id="${mediaId}"]`
      );
      if (targetLi) {
        const gallery = targetLi.closest("media-gallery");
        const index = Array.from(gallery.querySelectorAll("li")).indexOf(
          targetLi
        );

        targetLi.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });

        if (gallery?.slideshow?.select) {
          gallery.slideshow.select(index, undefined, { animate: true });
        }

        // console.log('➡️ Desktop gallery scrolled to index:', index);
        return;
      }
      requestAnimationFrame(attempt);
    };

    attempt();
  };

  /* ------------------ MOBILE ------------------ */
  const scrollToVariantMediaMobile = (variant) => {
    if (!variant?.featured_media?.id) return;
    const mediaId = variant.featured_media.id;

    const attemptScroll = () => {
      const targetSlide = document.querySelector(
        `slideshow-slide[data-media-id="${mediaId}"]`
      );
      if (targetSlide) {
        targetSlide.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
        // console.log("➡️ Mobile slideshow scrolled to media ID:", mediaId);
      } else {
        requestAnimationFrame(attemptScroll); // retry until element exists
      }
    };

    // Wait a bit to ensure the slideshow doesn't reset
    setTimeout(attemptScroll, 50);
  };

  const handleVariantChange = (variant) => {
    scrollToVariantMediaDesktop(variant);
    scrollToVariantMediaMobile(variant);
  };

  /* ------------------ EVENT BINDING ------------------ */
  document.querySelectorAll(".shopify-section").forEach((section) => {
    section.addEventListener("variant:update", (event) => {
      const variant = event.detail?.resource;

      const isMobile = window.matchMedia("(max-width: 749px)").matches;

      if (isMobile) {
        // console.log('📱 Mobile variant change detected:', variant);
        scrollToVariantMediaMobile(variant);
      } else {
        // console.log('💻 Desktop variant change detected:', variant);
        scrollToVariantMediaDesktop(variant);
      }
    });
    //
    const initialVariant = section.querySelector('[name="id"]')?.value;
    // console.log("Initial", initialVariant)
    if (initialVariant) {
      // Fetch the variant object from Shopify theme object
      const productJson = section.querySelector('[type="application/json"]');
      if (productJson) {
        const product = JSON.parse(productJson.textContent);
        // console.log("Product", product)
        if (product) handleVariantChange(product);
      }
    }
  });

  /* ------------------ OBSERVER ------------------ */
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.matches?.("media-gallery")) {
          // console.log('🖼️ Desktop media-gallery inserted:', node);
        }
        if (node.matches?.("slideshow-component")) {
          // console.log('🖼️ Mobile slideshow-component inserted:', node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
